<template>
  <div class="login-view">
    <div class="login">
      <div class="logo-container">
        <logo-vue></logo-vue>
      </div>
      <div class="container">
        <router-view :key="$route.path"></router-view>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col s12 mt10">
        <router-link :to="{ name: 'reset-password' }">{{$t('views.login.forgotPassword')}}</router-link>
        <router-link :to="{ name: 'register' }">{{$t('views.login.registerAccount')}}</router-link>
      </div>
    </div>-->
    <!-- <bankid></bankid> -->
  </div>
</template>

<script>
import LogoVue from '@common/Components/Logo-NONBETA.vue';

export default {
  name: 'LoginView',
  components: { LogoVue },
  mounted() {
    const body = document.querySelector('body');
    body.classList.remove('logged-in');
    body.classList.add('not-logged-in');
  },
  computed: {
    verified() {
      return (
        this.$route.query.hasOwnProperty('verifiedemail') &&
        this.$route.query.verifiedemail === 1
      );
    }
  }
};
</script>

<style lang="scss">
.login-view {
  .page-header {
    font-size: 25px;
    margin-bottom: 30px;
  }
  .page-sub-header {
    text-transform: none;
    font-size: 15px;
    margin-top: 10px;
    color: #888;
  }
  .button-container {
    margin-top: 50px;
    text-align: center;
  }
}
</style>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.container {
  padding-top: 0;
}

.login-view {
  // margin-top: $header-height;
  padding-bottom: 150px;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  height: 100vh;
  @media only screen and (min-width: $breakpoint-desktop) {
    padding-bottom: 10px;
  }
  .login {
    display: flex;
    max-width: 400px;
    flex-direction: column;
    align-items: center;
    align-self: center;
    position: relative;
    background-image: url(../../../public/images/login-background.svg);
    background-repeat: no-repeat;
    @media only screen and (min-width: $breakpoint-desktop) {
      // height: 60vh;
      background-image: none;
      padding-bottom: 10px;
    }
  }
}
.logo-container {
  min-height: 95px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: $breakpoint-desktop) {
    min-height: 165px;
  }
  svg {
    max-width: 60%;
    fill: black;
  }
}
a {
  // color: $symptoms-;
  display: block;
  margin-bottom: 10px;
  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
